module.exports = __webpack_public_path__ + "assets/InteriorAnglesDetailed.6201d051d4536c3ac4237702c9eb8117.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/InteriorAnglesDetailed.png
// module id = 526
// module chunks = 0